module.exports = __webpack_public_path__ + "media/images/recruitment/landing/mv_price-99264877d218de2b930042d61ff341bc.png";